import { useNavigate } from 'react-router-dom';

import { useGetProjectsSummaryQuery } from './api/adminProjectsApiSlice';
import { getAnnotationToolAdminProjectsPath } from '../../lib/routePaths';

interface UseAdminProjectsScreenResult {
  draftProjectsCount: number;
  inProgressProjectsCount: number;
  completedProjectsCount: number;
  totalProjectsCount: number;
  referenceStandardReviewProjectsCount: number;
  navigateToCreateProject: () => void;
  isProjectsSummaryLoading: boolean;
}
export const useAdminProjectsScreen = (): UseAdminProjectsScreenResult => {
  const navigate = useNavigate();
  const navigateToCreateProject = () => {
    navigate(`${getAnnotationToolAdminProjectsPath()}/create`);
  };

  const {
    data: projectsSummary,
    isLoading: isProjectsSummaryLoading,
    isFetching: isProjectsSummaryFetching,
  } = useGetProjectsSummaryQuery();

  return {
    draftProjectsCount: projectsSummary?.data?.draftProjectsCount ?? 0,
    inProgressProjectsCount: projectsSummary?.data?.inProgressProjectsCount ?? 0,
    completedProjectsCount: projectsSummary?.data?.completedProjectsCount ?? 0,
    totalProjectsCount: projectsSummary?.data?.totalProjectsCount ?? 0,
    referenceStandardReviewProjectsCount:
      projectsSummary?.data?.referenceStandardReviewProjectsCount ?? 0,
    isProjectsSummaryLoading: isProjectsSummaryLoading || isProjectsSummaryFetching,
    navigateToCreateProject,
  };
};
